import { SET_SLOT_DISPLAY } from "../actions";

export const slotDisplay = (state = {}, action) => {
  if (action.type === SET_SLOT_DISPLAY) {
    return action.payload;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/store/reducers/slotDisplay.js